(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8046],{

/***/ 98046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ categoryTree_CategoryTree; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./components/index.js + 172 modules
var components = __webpack_require__(70517);
// EXTERNAL MODULE: ./lib/getLinkProps.js
var getLinkProps = __webpack_require__(89729);
// EXTERNAL MODULE: ./assets/icons/index.js + 78 modules
var icons = __webpack_require__(17499);
// EXTERNAL MODULE: ./store/index.js + 7 modules
var store = __webpack_require__(12325);
// EXTERNAL MODULE: ./containers/categoryTree/CategoryTree.module.scss
var CategoryTree_module = __webpack_require__(55550);
var CategoryTree_module_default = /*#__PURE__*/__webpack_require__.n(CategoryTree_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./containers/categoryTree/CategoryTree.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable jsx-a11y/anchor-is-valid */












var CategoryName = function CategoryName(_ref) {
  var name = _ref.name,
      blank = _ref.blank,
      color = _ref.color;
  var words = name.split(' ');
  var lastWord = words[words.length - 1];
  var otherWords = words.slice(0, -1).join(' ');
  return blank ? /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
    style: color !== '' ? {
      color: color
    } : {},
    children: [otherWords, ' ', /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
      className: "with-icon",
      children: [lastWord, /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
        name: "blank"
      })]
    })]
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
    style: color !== '' ? {
      color: color
    } : {},
    children: name
  });
};

var CategoryTree = function CategoryTree(_ref2) {
  var _parent$color;

  var sidebar = _ref2.sidebar,
      savedQuery = _ref2.savedQuery,
      parent = _ref2.parent,
      currentSlug = _ref2.currentSlug,
      _ref2$isSearch = _ref2.isSearch,
      isSearch = _ref2$isSearch === void 0 ? false : _ref2$isSearch;
  var ref = (0,react.useRef)();
  var favoriteBrands = (0,es/* useSelector */.v9)(store/* favoriteBrandsSelector */.mN);
  var getLink = (0,react.useCallback)(function (_ref3) {
    var className = _ref3.className,
        linkHref = _ref3.linkHref,
        slug = _ref3.slug,
        name = _ref3.name,
        isBlanked = _ref3.isBlanked,
        color = _ref3.color;
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ActiveLink */.O$, {
      href: {
        pathname: linkHref,
        query: savedQuery || {}
      },
      as: {
        pathname: slug,
        query: savedQuery || {}
      },
      shallow: true,
      disableActive: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        className: className,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CategoryName, {
          name: name,
          blank: isBlanked,
          color: color
        })
      })
    });
  }, [savedQuery]);
  var getChildrens = (0,react.useCallback)(function (items) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: (CategoryTree_module_default()).container,
      children: items.map(function (_ref4) {
        var name = _ref4.name,
            slug = _ref4.slug,
            is_blanked = _ref4.is_blanked,
            _ref4$color = _ref4.color,
            color = _ref4$color === void 0 ? '' : _ref4$color;

        var _getLinkProps = (0,getLinkProps/* default */.Z)({
          type: isSearch ? 'search' : 'catalog',
          value: slug
        }),
            _getLinkProps2 = (0,slicedToArray/* default */.Z)(_getLinkProps, 1),
            linkHref = _getLinkProps2[0];

        return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          className: (CategoryTree_module_default()).item,
          children: getLink({
            className: parent ? (CategoryTree_module_default()).linkChildWithParent : (CategoryTree_module_default()).linkChild,
            linkHref: linkHref,
            slug: slug,
            name: name,
            isBlanked: is_blanked,
            color: color
          })
        }, slug);
      })
    });
  }, [parent, getLink, favoriteBrands]);
  var getCategories = (0,react.useCallback)(function (items) {
    return items.map(function (_ref5, index) {
      var name = _ref5.name,
          slug = _ref5.slug,
          childrens = _ref5.childrens,
          is_blanked = _ref5.is_blanked,
          _ref5$id = _ref5.id,
          id = _ref5$id === void 0 ? null : _ref5$id,
          _ref5$color = _ref5.color,
          color = _ref5$color === void 0 ? '' : _ref5$color,
          _ref5$isFav = _ref5.isFav,
          isFav = _ref5$isFav === void 0 ? false : _ref5$isFav;

      var _getLinkProps3 = (0,getLinkProps/* default */.Z)({
        type: isSearch ? 'search' : 'catalog',
        value: slug
      }),
          _getLinkProps4 = (0,slicedToArray/* default */.Z)(_getLinkProps3, 1),
          linkHref = _getLinkProps4[0];

      var favoriteBrandsChildren = parent && parent.brandId ? [] : (childrens === null || childrens === void 0 ? void 0 : childrens.filter(function (item) {
        return favoriteBrands.includes(String(item.brandId));
      }).sort(function (a, b) {
        return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
      })) || [];
      var childrenWithoutFavoutiteBrands = parent && parent.brandId ? childrens : favoriteBrands.length > 0 ? (childrens === null || childrens === void 0 ? void 0 : childrens.filter(function (item) {
        return !favoriteBrands.includes(String(item.brandId));
      })) || [] : childrens || [];
      return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: (0,clsx_m/* default */.Z)((CategoryTree_module_default()).item, isFav && index === favouriteCategories.length - 1 && (CategoryTree_module_default()).itemFav, (currentSlug === slug || currentSlug == id) && (CategoryTree_module_default()).activeLi),
        children: currentSlug === slug || currentSlug == id ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            ref: ref,
            className: parent ? (CategoryTree_module_default()).linkChildActive : (CategoryTree_module_default()).activeLink,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              style: color !== '' ? {
                color: color
              } : {},
              children: name
            })
          }), favoriteBrandsChildren && favoriteBrandsChildren.length > 0 && getChildrens(favoriteBrandsChildren), childrenWithoutFavoutiteBrands && childrenWithoutFavoutiteBrands.length > 0 && getChildrens(childrenWithoutFavoutiteBrands)]
        }) : getLink({
          className: parent ? (CategoryTree_module_default()).linkChild : (CategoryTree_module_default()).link,
          linkHref: linkHref,
          slug: slug,
          name: name,
          isBlanked: is_blanked,
          color: color
        })
      }, slug);
    });
  }, [sidebar, parent, currentSlug, getChildrens, getLink, favoriteBrands]);
  var favouriteCategories = (0,react.useMemo)(function () {
    var _sidebar$filter$map$s;

    return (_sidebar$filter$map$s = sidebar.filter(function (item) {
      return favoriteBrands.includes(String(item.brandId));
    }).map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        isFav: true
      });
    }).sort(function (a, b) {
      return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
    })) !== null && _sidebar$filter$map$s !== void 0 ? _sidebar$filter$map$s : [];
  }, [sidebar, favoriteBrands]);
  var categoriesWithoutFavorites = (0,react.useMemo)(function () {
    var _sidebar$filter;

    return (_sidebar$filter = sidebar.filter(function (item) {
      return !favoriteBrands.includes(String(item.brandId));
    })) !== null && _sidebar$filter !== void 0 ? _sidebar$filter : [];
  }, [sidebar, favoriteBrands]);

  var _getLinkProps5 = (0,getLinkProps/* default */.Z)({
    type: isSearch ? 'search' : 'catalog',
    value: parent === null || parent === void 0 ? void 0 : parent.slug
  }),
      _getLinkProps6 = (0,slicedToArray/* default */.Z)(_getLinkProps5, 1),
      linkHref = _getLinkProps6[0];

  (0,react.useEffect)(function () {
    setTimeout(function () {
      var _ref$current;

      (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    }, 0);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
    className: (CategoryTree_module_default()).container,
    children: parent ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: (CategoryTree_module_default()).item,
        children: getLink({
          className: (CategoryTree_module_default()).link,
          linkHref: linkHref,
          slug: parent.slug,
          name: parent.name,
          isBlanked: parent.is_blanked,
          color: (_parent$color = parent === null || parent === void 0 ? void 0 : parent.color) !== null && _parent$color !== void 0 ? _parent$color : ''
        })
      }, parent.slug), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        className: (CategoryTree_module_default()).container,
        children: getCategories([].concat((0,toConsumableArray/* default */.Z)(favouriteCategories), (0,toConsumableArray/* default */.Z)(categoriesWithoutFavorites)))
      })]
    }) : getCategories(sidebar)
  });
};

/* harmony default export */ var categoryTree_CategoryTree = (CategoryTree);
;// CONCATENATED MODULE: ./containers/categoryTree/index.js


/***/ }),

/***/ 55550:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"CategoryTree_item__CX_57","link":"CategoryTree_link__Cs7ub","activeLink":"CategoryTree_activeLink__mNt6H","linkChild":"CategoryTree_linkChild__RpJtd","linkChildActive":"CategoryTree_linkChildActive__Cjrxw","container":"CategoryTree_container__C7KrH","itemFav":"CategoryTree_itemFav__P2UqN","linkChildWithParent":"CategoryTree_linkChildWithParent__wDsyo","activeLi":"CategoryTree_activeLi__PPfB4","load":"CategoryTree_load__RN3GA"};

/***/ })

}]);